export default __webpack_public_path__ + "static/bg-notes--mobile-143e234a88f57569d187e029e2af5146.jpg";